module.exports = __webpack_public_path__ + "static/media/websites.43d27287.svg";